module.exports = __webpack_public_path__ + "static/img/hospital.f66b1f77.png";